import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { Typography } from '../../../../../components/DesignSystem';
import YatTextInput from '../../GridItem/Link/TextInput';

export const CHARACTER_LIMIT_CLASS_NAME = 'input-character-limit';

export const BackIconWrapper = styled(motion.div)`
    display: flex;

    justify-content: center;
    align-items: center;

    width: 40px;
    height: 40px;
    padding: 15px;

    border-radius: 50%;

    background: ${({ theme }) => theme.shades.white[10]};
`;

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    flex-direction: column;
`;

export const InputContainer = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 10px;
    width: 100%;
`;

export const ErrorMessage = styled.span`
    display: inherit;
    margin: 0 auto 5px;
    padding: 0;
    color: ${({ theme }) => theme.colors.red};
    width: fit-content;
`;

interface StyledInputProps {
    $multiline: boolean;
    $isURLInvalid: boolean | undefined;
}

export const StyledTypography = styled(Typography)`
    width: 100%;
`;

export const StyledInput = styled(YatTextInput)<StyledInputProps>`
    background: linear-gradient(109.49deg, rgba(255, 255, 255, 0.13) -4.86%, rgba(255, 255, 255, 0) 98.1%),
        linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000;
    border: 1px solid;
    border-image: linear-gradient(295.84deg, rgba(255, 255, 255, 0.15) 5.36%, rgba(255, 255, 255, 0) 41.35%);
    border-radius: 60px;
    border: ${({ $isURLInvalid }) => ($isURLInvalid ? `1px solid` : 'none')};
    border-color: ${({ theme }) => theme.colors.red};

    ${({ $multiline }) =>
        $multiline
            ? css`
                  padding: 10px 55px 10px 15px;
                  border-radius: 10px;
              `
            : css`
                  padding: 0 15px;
              `}
`;
